import "./class-component-hooks.ts";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VeeValidate from "vee-validate";
import { FETCH_CURRENT_PAGE, FETCH_MAIN_MENU, FETCH_PREVIEW_PAGE } from "./store/actions.names";

import { RETRIEVE_SESSION_DATA } from "./store/mutations.names";
import { VueMasonryPlugin } from "vue-masonry";
import VueVideoPlayer from "vue-video-player";
// require videojs style
import "video.js/dist/video-js.css";
// import 'vue-video-player/src/custom-theme.css'
import AOS from "aos";
import "aos/dist/aos.css";
import { TweenMax, TimelineMax } from "gsap";
import * as ScrollMagic from "scrollmagic";
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
Vue.use(VueVideoPlayer);
Vue.use(VeeValidate);
Vue.use(VueMasonryPlugin);
Vue.config.productionTip = false;
store.dispatch(FETCH_MAIN_MENU);

const isProd =
  process.env.NODE_ENV === "production" &&
  process.env.VUE_APP_DEVENV === "production";

store.commit(RETRIEVE_SESSION_DATA);

router.beforeEach((to, from, next) => {
  if (to.meta.loginRequired) {
    //  console.log(store.getters.authToken);
    if (store.getters.authToken) {
      if (to.meta.automatic) {
        next();
      } else {
        if (to.query.token && to.query.content_type) {
          store.dispatch(FETCH_PREVIEW_PAGE, to.query).then(() => {
            next();
          });
        } else {
          store.dispatch(FETCH_CURRENT_PAGE, to.path).then(() => {
            next();
          });
        }
      }
    } else {
      next("/login");
    }
  } else {
    if (to.meta.automatic) {
      next();
    } else {
      if (to.query.token && to.query.content_type) {
        store.dispatch(FETCH_PREVIEW_PAGE, to.query).then(() => {
          next();
        });
      } else {
        store.dispatch(FETCH_CURRENT_PAGE, to.path).then(() => {
          next();
        });
      }
    }
  }
});

new Vue({
  created() {
    AOS.init({ disable: "phone" });
  },
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
